<template>
  <div>
    <el-card shadow="hover" v-loading="loading">
      <div slot="header" class="header">
        <div class="title">
          <span>机构</span>
          <el-tag v-if="list.length" size="mini" type="info" style="margin-left:8px;">{{ list.length }} 条</el-tag>
        </div>
        <div class="actions">
          <el-input
            v-model.trim="query.keyword"
            size="small"
            clearable
            placeholder="搜索机构名称"
            style="width: 220px;"
            @keyup.enter.native="refresh"
          />
          <el-button size="small" icon="el-icon-refresh" @click="refresh">刷新</el-button>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreate">新增机构</el-button>
        </div>
      </div>

      <el-table :data="list" border stripe highlight-current-row empty-text="暂无机构">
        <el-table-column type="index" label="序号" width="80" />
        <el-table-column prop="name" label="机构名称" />
        <el-table-column label="操作" width="120" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" plain @click="onDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="新增机构" :visible.sync="createVisible" width="420px" :close-on-click-modal="false">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="机构名称" prop="name">
          <el-input v-model.trim="form.name" maxlength="128" show-word-limit placeholder="请输入机构名称" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="createVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="doCreate">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { searchOrgs, createOrg, deleteOrg } from "@/api";

export default {
  name: "Org",
  data() {
    return {
      list: [],
      createVisible: false,
      saving: false,
      loading: false,
      query: { keyword: "" },
      form: { name: "" },
      rules: {
        name: [{ required: true, message: "请输入机构名称", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.loading = true;
      try {
        const res = await searchOrgs({ keyword: this.query.keyword || "" });
        this.list = (res && res.data && res.data.list) || [];
      } catch (e) {
        this.$message.error("加载失败");
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.form = { name: "" };
      this.createVisible = true;
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate());
    },
    async doCreate() {
      this.$refs.formRef.validate(async (ok) => {
        if (!ok) return;
        this.saving = true;
        try {
          await createOrg(this.form.name);
          this.$message.success("已创建");
          this.createVisible = false;
          await this.refresh();
        } catch (e) {
          this.$message.error("创建失败（需要 admin 权限）");
        } finally {
          this.saving = false;
        }
      });
    },
    async onDelete(row) {
      const id = Number(row && row.id);
      if (!id) return;
      try {
        await this.$confirm(`确认删除机构？\n机构：${row.name || "-"}`, "删除", { type: "warning" });
      } catch (e) {
        return;
      }
      this.saving = true;
      try {
        await deleteOrg(id);
        this.$message.success("已删除");
        await this.refresh();
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && (e.response.data.message || e.response.data.errMsg)) ||
          ((e && e.message) ? e.message : "");
        if (String(msg).indexOf("org_has_cabinets") >= 0) {
          this.$message.error("删除失败：该机构下存在智能柜，请先处理智能柜");
        } else {
          this.$message.error("删除失败（需要 admin 权限）");
        }
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  display: flex;
  align-items: center;
  font-weight: 600;
}
.actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>

